import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { App } from "./App";
import "./styles.css";

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <BrowserRouter basename={resolveBasename()}>
      <App />
    </BrowserRouter>
  </StrictMode>,
);

/**
 * When deployed behind nginx at `/{UUID}/sibit-dev/`, `location.pathname`
 * starts with that prefix. We derive basename from the script URL so relative
 * routing works without build-time knowledge of the prefix.
 */
function resolveBasename(): string {
  // index.html lives at the prefix root, so baseURI is `${prefix}/`.
  // React Router basename wants the prefix without trailing slash.
  const { pathname } = new URL(document.baseURI);
  return pathname.replace(/\/$/, "");
}
